<template>
  <div class="main">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <main v-loading="loading">
      <h2>学习详情</h2>
      <div class="title_view">
        <p>学员名称： <span>{{ $parent.rowInfo.RealName }}</span></p>
        <p>科室： <span>{{ $parent.rowInfo.DepartmentName }}</span></p>
        <p>职位： <span>{{ $parent.rowInfo.PTitle }}</span></p>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="序号" width="100">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
        >
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="foot_box">
        <div class="foot_pagetions">
          <p>共有{{ total }}条记录，当前第{{ currentPage }}/{{ pagesun }}页</p>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="showpageindex"
            :page-size="pageSize"
            :page-sizes="pagesizesarr"
            layout="prev, pager, next,sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import training from "@/api/trainingApi";

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      formColumns: [
        {
          prop: "Score",
          label: "获得学分",
        },
        {
          prop: "getTime",
          label: "获得时间",
        },
        {
          prop: "Types",
          label: "学分类型",
        },
        {
          prop: "itemName",
          label: "任务名称",
        },
      ],
      showpageindex: 1, //显示的索引盒子
      currentPage: 1, //  当前页数
      pageSize: 10, //每页的条数
      pagesizesarr: [5, 10, 20, 50, 100],
      pagesun: "", //一共多少页
      total: 100,
    };
  },
  props: ["cutcoms"],
  methods: {
    async init() {
      this.loading = true;
      const obj = {
        trainId: this.$parent.examRow.tranid,
        studentId: this.$parent.rowInfo.StudentID,
        pageNum: this.currentPage - 1,
        pageSize: this.pageSize,
      };
      const { data } = await training.getStudetail(obj);
      if (data.Status == 200) {
       let newarr  = data.Data.list.map((item) => {
          if (item.Type == "exam") {
            item.Types = "考试";
          } else if (item.Type == "exercise") {
            item.Types = "练习";
          } else if (item.Type == "courseware") {
            item.Types = "课件";
          } else if (item.Type == "video") {
            item.Types = "视频";
          }
          item.time = new Date(item.getTime).getTime();
          return item
        });
        this.tableData = newarr.sort((a, b) => b.time - a.time);
        this.total = data.Data.total;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.$message({
          message: data.Data,
          type: "warning",
        });
      }
      console.log(data);
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.init(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.init();
    },
    // 返回按键
    backBtn() {
      this.$destroy();
      if(this.$parent.type == 0){
        this.cutcoms(6);
      }else{
        this.cutcoms(1);
      }
    },
  },
  activated() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100%;
  min-height: 780px;
}
// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  border-radius: 0px 0px 10px 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.title_view {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  > p {
    margin-right: 42px;
    color: #999999;
    span {
      color: #000;
    }
  }
}
main {
  padding: 24px;
  h2 {
    margin-bottom: 24px;
  }
}
// 分页
.foot_box {
  position: relative;
  height: 86px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .cell {
  text-align: center;
}
</style>